import {
  OPTL_HEADER_TRACE_FLAGS,
  OPTL_HEADER_VERSION,
} from './openTelemetry.constants'

export const generateOPTLTraceparent = (traceId: string, spanId: string) =>
  `${OPTL_HEADER_VERSION}-${traceId}-${spanId}-${OPTL_HEADER_TRACE_FLAGS}`
